import { DataGrid } from '@mui/x-data-grid'
import React, { Component } from 'react'
import { ImagePaths } from '../../../Utility/ImagePaths'
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, Tooltip } from '@mui/material';
import DatePicker from '../../../Components/DatePicker/DatePicker';
import { DateTime } from 'luxon';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { t } from "i18next";
import { withTranslation } from 'react-i18next';
import CommonGridHeader from '../../../Components/Common Components/CommonComponents';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { AmountFormat } from "../../../Components/CommonFunctions/CommonFunctions";
import { CurrencySymbol } from '../../../Utility/Constants';
import NewDatePicker from '../../../Components/DatePicker/NewDatePicker';

class DoctorReport extends Component {
  state = {
    pageSize: 10,
    isErrorMsg: false,
    isErrorMsgText: '',
    refReportList: [],
    totalReferral: 0,
    fromDate: "",
    toDate: "",
    dateFilter: 1,
    QueryFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    QueryToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    searchkey : ''
  }

  componentDidMount() {
    this.getDoctorReport()
  }
  // componentWillReceiveProps(props){
  //   if(props.search_key != this.state.searchkey){
  //       this.setState({
  //           searchkey: props.search_key ? props.search_key : ''
  //       },() => {
  //           this.getDoctorReport()
  //       })
  //   }
  // }

  msgClose(){
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      isSuccessMsg: false,
      isSuccessMsgText: "",
    })
}

  CustomDates = (FromDate, ToDate) => {
    this.setState({
      QueryFromDate: FromDate,
      QueryToDate: ToDate,
      datePickerPop: false
    }, () => this.getDoctorReport())
  }
  PopClose = () => {
    this.setState({
      datePickerPop: false,
      QueryFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      QueryToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateFilter: 1,
    }, () => this.getDoctorReport())
  }
  handleDate = () => {
    var today = DateTime.now().toFormat('yyyy-MM-dd')
    var yesterday = DateTime.now().minus({ days: 1 }).toFormat('yyyy-MM-dd')
    var startweek = DateTime.now().minus({ days: 7 }).toFormat('yyyy-MM-dd')
    var startmonth = DateTime.now().minus({ days: 30 }).toFormat('yyyy-MM-dd')
    var startOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).startOf('week').minus({ days: 1 }).toFormat('yyyy-MM-dd')
    var endOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).endOf('week').minus({ days: 1 }).toFormat('yyyy-MM-dd')
    const startOfPreviousMonth = DateTime.now().minus({ month: 1 }).startOf('month').toFormat('yyyy-MM-dd');
    const endOfPreviousMonth = DateTime.now().minus({ month: 1 }).endOf('month').toFormat('yyyy-MM-dd');


    if (this.state.dateFilter === 0) {
      this.setState({
        QueryFromDate: "",
        QueryToDate: "",
      }, () => this.getDoctorReport())
    }
    else if (this.state.dateFilter === 1) {
      this.setState({
        QueryFromDate: today,
        QueryToDate: today,
      }, () => this.getDoctorReport()
      )

    }
    else if (this.state.dateFilter === 2) {
      this.setState({
        QueryFromDate: yesterday,
        QueryToDate: yesterday,
      }, () => this.getDoctorReport())
    }
    else if (this.state.dateFilter === 3) {
      this.setState({
        QueryFromDate: startOfPreviousWeek,
        QueryToDate: endOfPreviousWeek,
      }, () => this.getDoctorReport())
    }
    else if (this.state.dateFilter === 4) {
      this.setState({
        QueryFromDate: startOfPreviousMonth,
        QueryToDate: endOfPreviousMonth,
      }, () => this.getDoctorReport())
    }
    else if (this.state.dateFilter === 5) {
      this.setState({ datePickerPop: true })
    }
  }

  DateHelperText = () => {
    if (this.state.dateFilter === 0) {
      return ""
    }
    else if (this.state.dateFilter === 1) {
      return DateTime.now().toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 2) {
      return DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')
    }
    else if (this.state.dateFilter === 3) {
      // return `${DateTime.now().minus({ days: 7 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
      const startOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).startOf('week');
      const endOfPreviousWeek = DateTime.now().minus({ weeks: 1 }).endOf('week');
      return `${startOfPreviousWeek.minus({ days: 1 }).toFormat('dd-MM-yyyy')} to ${endOfPreviousWeek.minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.dateFilter === 4) {
      // return `${DateTime.now().minus({ days: 30 }).toFormat('dd-MM-yyyy')}  to  ${DateTime.now().minus({ days: 1 }).toFormat('dd-MM-yyyy')}`
      const startOfPreviousMonth = DateTime.now().minus({ month: 1 }).startOf('month');
      const endOfPreviousMonth = DateTime.now().minus({ month: 1 }).endOf('month');
      return `${startOfPreviousMonth.toFormat('dd-MM-yyyy')} to ${endOfPreviousMonth.toFormat('dd-MM-yyyy')}`
    }
    else if (this.state.dateFilter === 5) {
      return `${this.state.QueryFromDate.split("-").reverse().join("-")}  to  ${this.state.QueryToDate.split("-").reverse().join("-")}`
    }
  }
  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }
  getDoctorReport = () => {
    try { 
    this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.LAB_DOCTOR_REPORT + "?from_date=" + this.state.QueryFromDate + "&to_date=" + this.state.QueryToDate + "&search_key=" + this.state.searchkey)
        .then(response => {
          if (response.data.status === "success") {
            this.setState({
              refReportList: response.data.data,
              totalReferral: response.data.total_referral,
            },()=>{this.LoaderFunction(false)})
          }
        }).catch(e => {
          this.LoaderFunction(false)
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: e.response.data.message
          })
        })

    } catch (e) {
      this.LoaderFunction(false)
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: e.message
      })
    }
  }

  getDoctorReportPrint = () => {
    try {
      this.setState({disableBtn: true})
      RestAPIService.getAll(Serviceurls.LAB_DOCTOR_REPORT_PRINT + "?export_type=pdf" +  "&from_date=" + this.state.QueryFromDate + "&to_date=" + this.state.QueryToDate + "&search_key=" + this.state.searchkey).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({disableBtn: false})
        }).catch((error) => {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error.reponse.data.message,
            disableBtn: false,
          })
        })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: t("PrintError"),
        disableBtn: false,
      })
    }
  }

  getDoctorReportexcel = () => {
    try {
      this.setState({disableBtn: true})
      RestAPIService.excelGet(Serviceurls.LAB_DOCTOR_REPORT_PRINT + "?export_type=excel" +  "&from_date=" + this.state.QueryFromDate + "&to_date=" + this.state.QueryToDate + "&search_key=" + this.state.searchkey).
        then((response) => {
          if(response.data){
          var pom = document.createElement('a');
          var csvContent = response.data; //here we load our csv data 
    
          let filename = response.headers["content-disposition"].split("filename=")[1]
    
          var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
          var url = URL.createObjectURL(blob);
          pom.href = url;
          pom.setAttribute('download', filename ? filename : 'registry.xlsx');
          pom.click();
          this.setState({disableBtn: false})
          }
        }).catch((error) => {
          this.setState({
            isErrorMsg: true,
            isErrorMsgText: error.response.data.message,
            disableBtn: false,
          })
        })
    } catch (error) {
      this.setState({
        isErrorMsg: true,
        isErrorMsgText: t("PrintError"),
        disableBtn: false,
      })
    }
  }

  render() {
    const {t} = this.props
    this.state.refReportList.forEach((element, index) => {
      element.sno = index + 1
    })

    const columns = [
      {
        field: 'sno', headerName: t("SNo"), sortable: false, flex: 0.05,
      },
      { field: 'reffered_by', headerName: t("DoctorName"), sortable: false, flex: 0.2 ,
      renderCell:(params)=>(<div>{params?.row?.reffered_by?.length > 25 ? <Tooltip placement='top' title={params.row.reffered_by} arrow><div>{params.row.reffered_by.slice(0,25) + "..."}</div></Tooltip> : params.row.reffered_by}</div>) },
      { field: 'reffered_reg_no', headerName: t("Registration No"), sortable: false, flex: 0.25 , headerAlign: "center", align: "center",
      renderCell:(params)=>(<div>{params?.row?.reffered_reg_no?.length > 25 ? <Tooltip placement='top' title={params.row.reffered_reg_no} arrow><div>{params.row.reffered_reg_no.slice(0,25) + "..."}</div></Tooltip> : params.row.reffered_reg_no}</div>)},
      { field: 'patient_count', headerName: t("noofPatients"), sortable: false, flex: 0.25 ,
      renderCell:(params)=>(<div>{params?.row?.patient_count?.length > 25 ? <Tooltip placement='top' title={params.row.patient_count} arrow><div>{params.row.patient_count.slice(0,25) + "..."}</div></Tooltip> : params.row.patient_count}</div>)},
      { field: 'total_amount', headerName: t("TotalAmount") +`(${CurrencySymbol})`, sortable: false, flex: 0.25,type:"number" ,
      renderCell:(params)=>(<div>{AmountFormat(params.row.total_amount || 0)?.replace(`${CurrencySymbol}`, "")}</div>)}
    ]
    return (
      <div className='reports_container'>
        <div className='reports_header_card'>
          <div className='reports_doctor_left'>
            <div className=''>
              <div className='reports_bill_box_one'>
                {AmountsCard(t("totalRef"),this.state.totalReferral,true)}
              </div>
            </div>
          </div>
          <div className='reports_doctor_right'>
            <div className='report_date_picker'>
              <div className='eMed_rts_date_pick'>
                <FormControl >
                  <InputLabel>{t("SelectDate")}</InputLabel>
                  <Select sx={{  height: '2.2vw', cursor: "pointer",marginRight:"1vw",width:"10vw"}}
                    size='small'
                    onChange={(event) => { this.setState({ dateFilter: event.target.value }, () => this.handleDate()) }}
                    value={this.state.dateFilter}
                    labelId="demo-simple-select-required-label"
                    label={t("SelectDate")}
                  >
                    {/* <MenuItem value={0}>{t("All")}</MenuItem> */}
                    <MenuItem value={1}>{t("Today")}</MenuItem>
                    <MenuItem value={2}>{t("Yesterday")}</MenuItem>
                    <MenuItem value={3}>{t("Lastweek")}</MenuItem>
                    <MenuItem value={4}>{t("LastMonth")}</MenuItem>
                    <MenuItem value={5} onClick={() => { this.setState({ datePickerPop: true }) }} >{t("Custom")}</MenuItem>
                  </Select>
                  <FormHelperText id="eMed_form_helpertext">{this.DateHelperText()}</FormHelperText>
                </FormControl>
              </div>
              {this.state.datePickerPop ? <NewDatePicker PopClose={this.PopClose} CustomDates={this.CustomDates} /> : null}
            </div>
              <img className='reports_print' emed_tid='Doctor_Report_Print_btn' src={ImagePaths.LabPrintIcon.default} onClick={()=>{
                if(!this.state.disableBtn){
                  this.getDoctorReportPrint()
                }}} alt='print' />

              <img className='eMed_rts_upload' emed_tid='Doctor_Report_Print_btn' src={ImagePaths.LabUploadButton.default} onClick={()=>{
                if(!this.state.disableBtn){
                 this.getDoctorReportexcel()
                }}} alt='upload' />
          </div>
        </div>

        <div className='reports_table_card'>
          <DataGrid
            rows={this.state.refReportList}
            columns={columns}
            hideFooterSelectedRowCount
            getRowId={(row) => row.sno}
            loading={this.state.isLoader}
            pageSize={this.state.pageSize}
            onPageSizeChange={(newPageSize) => {
              this.setState({ pageSize: newPageSize })
            }}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            rowsPerPageOptions={[10, 20, 30]}
            pagination
            components={{
              Toolbar: CommonGridHeader.CommonToolBar,
              NoRowsOverlay:()=>(
                <Stack height="100%" alignItems="center" justifyContent="center">
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            headerHeight={40}
          />
        </div>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : this.state.isSuccessMsg ?
            <ToastMsg
              severity={'success'}
              msg={this.state.isSuccessMsgText}
              msgPop={this.msgClose.bind(this)}
            /> : null
        }
      </div>

    )
  }
}


export default withTranslation()(DoctorReport)